import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const PIE_COLORS = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7f7f",
  "#8dd1e1",
  "#a4de6c",
  "#d0ed57",
  "#bc80bd",
];

interface BankData {
  name: string;
  value: number;
}

interface BankInterestChartProps {
  data: BankData[] | undefined;
  isLoading?: boolean;
}

export function BankInterestChart({ data, isLoading = false }: BankInterestChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>ความสนใจธนาคาร</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-80 flex items-center justify-center text-muted-foreground">
            กำลังโหลด...
          </div>
        ) : !data || data.length === 0 ? (
          <div className="h-80 flex items-center justify-center text-muted-foreground">
            ไม่มีข้อมูล
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={110}>
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
